import { useCallback } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";

export function useDashboardNavigation() {
  const history = useHistory();
  const { url } = useRouteMatch();

  const arenaUrl = url.replace(/\/entity\/[^/]+(\/position\/[^/]+)?$/, "");

  const navigateToArena = useCallback(() => {
    history.push(arenaUrl);
  }, [history, arenaUrl]);

  const navigateToEntity = useCallback(
    (entityId: number, entityName?: string | null) => {
      history.push({ pathname: `${arenaUrl}/entity/${entityId}`, state: { entityName } });
    },
    [history, arenaUrl],
  );

  const navigateToPosition = useCallback(
    (positionId: number, entityId: number, entityName?: string | null) => {
      history.push({
        pathname: `${arenaUrl}/entity/${entityId}/position/${positionId}`,
        state: { entityName },
      });
    },
    [history, arenaUrl],
  );

  return { navigateToArena, navigateToEntity, navigateToPosition };
}
